import script from "./PayslipsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PayslipsPage.vue?vue&type=script&setup=true&lang=ts"

import "./PayslipsPage.vue?vue&type=style&index=0&id=adb591ec&scoped=true&lang=css"
import "./PayslipsPage.vue?vue&type=style&index=1&id=adb591ec&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-adb591ec"]])

export default __exports__